import * as tslib_1 from "tslib";
import { Directive, ElementRef, Input, Renderer } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { finalize } from 'rxjs/operators/finalize';
import { ObjectWithLinks } from '../services';
var ApiImageDirective = /** @class */ (function () {
    function ApiImageDirective(el, renderer, http) {
        this.el = el;
        this.renderer = renderer;
        this.http = http;
        /** In case of mutiple images. Whitch image to to shown */
        this.position = 0;
        /** Defaut image */
        this.defaultImage = "data:image/svg+xml,%3csvg fill='%23999999' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M0 0h24v24H0zm0 0h24v24H0zm21 19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2' fill='none'/%3e%3cpath d='M0 0h24v24H0z' fill='none'/%3e%3cpath d='M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z'/%3e%3c/svg%3e";
    }
    ApiImageDirective.prototype.ngOnInit = function () {
        var _this = this;
        if (this.item && this.item[this.property]) {
            var imageNames = this.item[this.property];
            // Single image
            if (typeof imageNames == 'string') {
                this.url = this.getFileUrl(imageNames);
            }
            else {
                var list = imageNames;
                this.url = this.getFileUrl(list[this.position]);
            }
            var sub_1 = this.http
                .head(this.url)
                .pipe(finalize(function () { return _this.updateElemnet(); }))
                .subscribe(function () { return sub_1.unsubscribe(); }, function (error) { return (_this.url = _this.defaultImage); });
        }
        else {
            if (!this.url)
                this.url = this.defaultImage;
            this.updateElemnet();
        }
    }; // ngOnInit()
    ApiImageDirective.prototype.updateElemnet = function () {
        if (this.el.nativeElement.localName === 'img') {
            this.el.nativeElement.src = this.url;
        }
        else {
            this.el.nativeElement.style.backgroundImage = 'url(' + this.url + ')';
        }
    }; // updateElemnet()
    ApiImageDirective.prototype.getUrl = function () {
        return this.item._links.self.href + '/' + this.property;
    }; // getUrl()
    ApiImageDirective.prototype.getFileUrl = function (fileName) {
        return this.getUrl() + '/' + fileName;
    };
    tslib_1.__decorate([
        Input(),
        tslib_1.__metadata("design:type", String)
    ], ApiImageDirective.prototype, "url", void 0);
    tslib_1.__decorate([
        Input(),
        tslib_1.__metadata("design:type", Number)
    ], ApiImageDirective.prototype, "position", void 0);
    tslib_1.__decorate([
        Input(),
        tslib_1.__metadata("design:type", ObjectWithLinks)
    ], ApiImageDirective.prototype, "item", void 0);
    tslib_1.__decorate([
        Input(),
        tslib_1.__metadata("design:type", String)
    ], ApiImageDirective.prototype, "property", void 0);
    ApiImageDirective = tslib_1.__decorate([
        Directive({
            selector: '[extApiImage]'
        }),
        tslib_1.__metadata("design:paramtypes", [ElementRef, Renderer, HttpClient])
    ], ApiImageDirective);
    return ApiImageDirective;
}());
export { ApiImageDirective };
//# sourceMappingURL=api-image.directive.js.map